console.log('BH PREFLIGHT LOADED EARLY ✅', new Date().toISOString());

(function () {
  // 1) Empêcher le crash "menu-drawer already been used"
  // On wrap customElements.define pour ignorer les re-definitions
  if (!window.__BH_CE_PATCH__) {
    window.__BH_CE_PATCH__ = true;
    const _define = customElements.define.bind(customElements);

    customElements.define = function (name, ctor, opts) {
      try {
        // si déjà défini -> on ignore (au lieu de throw)
        if (customElements.get(name)) {
          console.warn('BH preflight: skip duplicate custom element define:', name);
          return;
        }
      } catch (e) {}
      return _define(name, ctor, opts);
    };
  }

  // 2) Empêcher le crash "Identifier DetailsDisclosure already declared"
  // On empêche la 2e exécution du fichier en retirant tout duplicat immédiatement
  function dedupe(srcPart) {
    const list = [...document.scripts].filter(s => (s.src || '').includes(srcPart));
    if (list.length > 1) {
      list.slice(1).forEach(s => {
        console.warn('BH preflight: removing duplicate script tag:', s.src);
        s.remove();
      });
    }
  }

  dedupe('/assets/details-disclosure.js');
  dedupe('/assets/details-modal.js');
  dedupe('/assets/global.js');

  // 3) Bloquer les duplicats injectés après coup (hot reload/apps)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (!n || n.nodeType !== 1) continue;
        if (n.tagName === 'SCRIPT') {
          const src = n.src || '';
          if (!src) continue;

          if (
            src.includes('/assets/details-disclosure.js') ||
            src.includes('/assets/details-modal.js') ||
            src.includes('/assets/global.js')
          ) {
            // si déjà présent une fois -> supprime
            const count = [...document.scripts].filter(s => (s.src || '') === src).length;
            if (count > 1) {
              console.warn('BH preflight: blocked duplicate injection:', src);
              n.remove();
            }
          }
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
